import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { share as shareApi } from "@/lib/api";
import { parseDSL } from "@/lib/dsl-parser";
import DiagramRenderer from "@/components/editor/DiagramRenderer";

export default function Embed() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [parsedGraph, setParsedGraph] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const text = searchParams.get("text");
    if (text) {
      try {
        const parsed = parseDSL(decodeURIComponent(text));
        setParsedGraph(parsed);
      } catch {
        setError("Failed to parse diagram");
      }
      return;
    }

    if (id) {
      shareApi
        .get(id)
        .then((res) => {
          const parsed = parseDSL(res.data.dsl_code);
          setParsedGraph(parsed);
        })
        .catch(() => setError("Diagram not found"));
    }
  }, [id, searchParams]);

  // Listen for postMessage updates from parent
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === "update-diagram" && event.data.code) {
        try {
          const parsed = parseDSL(event.data.code);
          setParsedGraph(parsed);
        } catch {}
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#94a3b8",
          fontFamily: "Manrope, sans-serif",
          fontSize: 14,
        }}
        data-testid="embed-error"
      >
        {error}
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: "#fafbfc",
        backgroundImage: "radial-gradient(circle, #e2e8f0 1px, transparent 1px)",
        backgroundSize: "20px 20px",
      }}
      data-testid="embed-container"
    >
      <DiagramRenderer graph={parsedGraph} />
    </div>
  );
}
